module.exports = __webpack_public_path__ + "static/media/arrow_icon.eea2a1d2.svg";